<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="100"
    offset-y
    content-class="elevation-1"
  >
    <template #activator="activator">
      <slot name="activator" v-bind="activator"></slot>
    </template>

    <v-card>
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ userName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense>
        <router-link to="/master_admin/profiles">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>プロフィール設定</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/master_admin/emails">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-email</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>メールアドレス変更</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>
      <v-card-actions>
        <LogoutBtn />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import LogoutBtn from '@/components/commons/LogoutBtn'

export default {
  name: 'AccountMenu',
  components: { LogoutBtn },
  props: {
    userName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      menu: false
    }
  }
}
</script>
